import { useState, useEffect } from 'react';

const STATS = [
  { value: '24h', label: '全天候更新' },
  { value: '10000+', label: '热门视频资源' },
  { value: '99.9%', label: '服务稳定在线' },
];

export default function HeroSection() {
  const [imgError, setImgError] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const hero = document.getElementById('hero');
      if (!hero) return;
      const scrollY = window.scrollY;
      const parallax = hero.querySelector<HTMLDivElement>('.hero-visual');
      if (parallax) {
        parallax.style.transform = `translateY(${scrollY * 0.15}px)`;
      }
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      const headerHeight = 64;
      const top = target.getBoundingClientRect().top + window.scrollY - headerHeight;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative min-h-[520px] md:min-h-[620px] flex items-center overflow-hidden bg-background-50 pt-16"
    >
      {/* Background decorative elements */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-20 right-1/4 w-72 h-72 md:w-96 md:h-96 rounded-full bg-primary-100/40 blur-3xl"></div>
        <div className="absolute bottom-10 left-1/4 w-64 h-64 md:w-80 md:h-80 rounded-full bg-accent-100/30 blur-3xl"></div>
      </div>

      <div className="relative w-full px-4 md:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-8 md:gap-12 lg:gap-16">
          {/* Left: Text Content */}
          <div className="flex-1 w-full text-center lg:text-left pt-6 md:pt-0">
            {/* Tag */}
            <span className="inline-block px-3 py-1 mb-4 text-xs md:text-sm font-medium rounded-full bg-accent-100 text-accent-700 whitespace-nowrap">
              🔥 今日热门 · 实时吃瓜
            </span>

            {/* H1 */}
            <h1 className="font-heading text-2xl md:text-3xl lg:text-4xl xl:text-5xl font-bold text-foreground-950 leading-tight mb-4">
              51吃瓜网在线观看
              <br className="hidden sm:block" />
              <span className="text-primary-500">高清娱乐资讯平台</span>
            </h1>

            {/* Slogan */}
            <p className="text-sm md:text-base text-foreground-500 font-medium mb-5">
              汇聚全网热门吃瓜视频，随时随地畅享高清影视娱乐
            </p>

            {/* Description */}
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-6">
              51吃瓜网在线观看为您提供最新最全的51吃瓜视频在线观看服务，涵盖51cg吃瓜直播、51吃瓜影视免费观看、吃瓜在线视频等丰富内容。
              平台每日更新海量热门视频资源，致力于打造优质的吃瓜视频在线观看体验，让每一位用户都能轻松畅享高清吃瓜内容。
            </p>

            {/* Stats */}
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mb-6">
              {STATS.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-lg md:text-xl font-bold text-primary-500 font-heading">
                    {stat.value}
                  </div>
                  <div className="text-xs text-foreground-500 mt-0.5">{stat.label}</div>
                </div>
              ))}
            </div>

            {/* CTAs */}
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#media"
                onClick={(e) => handleNavClick(e, '#media')}
                className="w-full sm:w-auto px-6 py-3 rounded-lg bg-primary-500 text-white font-medium text-sm hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap text-center cursor-pointer"
              >
                <i className="ri-play-circle-line mr-1.5"></i>立即观看
              </a>
              <a
                href="#topics"
                onClick={(e) => handleNavClick(e, '#topics')}
                className="w-full sm:w-auto px-6 py-3 rounded-lg border border-secondary-300 text-foreground-700 font-medium text-sm hover:bg-secondary-50 hover:border-secondary-400 transition-colors duration-200 whitespace-nowrap text-center cursor-pointer"
              >
                <i className="ri-fire-line mr-1.5"></i>热门话题
              </a>
            </div>
          </div>

          {/* Right: Visual */}
          <div className="flex-1 w-full lg:w-auto flex justify-center hero-visual transition-transform duration-100">
            {!imgError ? (
              <div className="relative w-full max-w-md lg:max-w-lg aspect-[4/3] rounded-2xl overflow-hidden bg-background-100">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20vibrant%20abstract%20digital%20art%20illustration%20of%20entertainment%20news%20and%20social%20media%20gossip%20concept%2C%20warm%20coral%20and%20amber%20gradient%20tones%2C%20stylized%20speech%20bubbles%20and%20play%20icons%20floating%20in%20dynamic%20abstract%20composition%2C%20soft%20golden%20light%20background%20with%20subtle%20texture%2C%20modern%20editorial%20design%20aesthetic%2C%20clean%20minimal%20negative%20space%2C%20contemporary%20digital%20art%20style%2C%20warm%20and%20inviting%20atmosphere&width=800&height=600&seq=hero-main-visual&orientation=landscape"
                  alt="51吃瓜网在线观看 - 高清娱乐资讯平台主视觉"
                  className="w-full h-full object-cover"
                  onError={() => setImgError(true)}
                />
              </div>
            ) : (
              <div className="relative w-full max-w-md lg:max-w-lg aspect-[4/3] rounded-2xl bg-background-100 flex items-center justify-center">
                <div className="text-center text-foreground-400">
                  <i className="ri-image-line text-4xl md:text-5xl mb-2 block"></i>
                  <span className="text-sm">51吃瓜网在线观看</span>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}